import React from 'react';
import './style.scss';

export const Deleteable = ({ onDelete, children }) => {
  return (
    <div className={'deleteable-container'}>
      {children}
      <div className={'delete-button'} onClick={onDelete}>
        <img src='/icons/delete.svg' />
      </div>
    </div>
  );
};
